/**
 * Web `ThemeScope`: publishes theme tokens as CSS custom properties on an
 * invisible wrapper element.
 *
 * Renders a role-less `display: contents` div carrying the `tokensToCssVars`
 * output as inline style, so CSS Modules below it resolve `var(--…)` with no
 * `<style>`-tag bookkeeping and SSR/hydration safety for free.
 * `display: contents` keeps the div out of flex/grid layout while custom
 * properties still inherit through it; the known `display: contents` a11y
 * hazards don't apply to a non-interactive, role-less element.
 */

import type { ReactNode } from 'react';

import { tokensToCssVars } from './theme.helpers';
import type { Theme } from './tokens';

export function ThemeScope({ tokens, children }: { tokens: Theme; children: ReactNode }) {
    return <div style={{ display: 'contents', ...tokensToCssVars(tokens) }}>{children}</div>;
}
